export enum recruiterPricingTypes {
  FETCH_RECRUITER_PRICING_REQUEST = "FETCH_RECRUITER_PRICING_REQUEST",
  FETCH_RECRUITER_PRICING_SUCCESS = "FETCH_RECRUITER_PRICING_SUCCESS",
  FETCH_RECRUITER_PRICING_FAILURE = "FETCH_RECRUITER_PRICING_FAILURE",
}